import React, { Component } from "react";
import Styles from "./styles.css";
import { CONTEXT_ROOT } from "../../utils";
import * as api from "../../state/api"
import { updateComponent } from '../../state/actions/componentsActions'
import {  withStyles } from '../../styles/withStyles'
import { connect } from 'react-redux'
import { PropTypes } from 'prop-types'
export const Plan = {
  FLEX: "FLEX",
  FLAT: "FLAT",
  FLEXCRS:"FLEXCRS",
  FLATCRS:"FLATCRS"
};

export class PlanToolbar extends Component {
  constructor(props) {
    super(props)
  }
  state = {
    plan: "",
    showTooltip: false
  };
  componentDidMount() {
    const { component, dispatch, queryParam,queryRefParam } = this.props
    if(component && component.id==="POSPLAN-PLAN") {
      let body = component.fetchPosPlan.body
      let url = component.fetchPosPlan.url
      return api.FetchPOSPlan(url,body).then(json => {
        const plan = json && json.payLoad && json.payLoad.Plan;
        const refCode = json && json.payLoad && json.payLoad.ReferalCode;
        if(plan) {
          if(!queryParam || (!queryRefParam && !!queryParam && queryParam===plan) || (!!queryRefParam && queryRefParam!==refCode)){
            var refresh =!!refCode? window.location.protocol + "//" + window.location.host + window.location.pathname + "?ref="+refCode+"&plan=" + plan: window.location.protocol + "//" + window.location.host + window.location.pathname + "?plan=" + plan;    
            window.history.pushState({ path: refresh }, '', refresh);
          }
          dispatch(updateComponent(component.id, { value: plan}));
          this.setState({ plan });
        }
      })
    }
  }
  render() {
    const { queryParam, posplanInDB } = this.props;
    const { plan } = this.state;
    const queryPlanName = queryParam && queryParam.toUpperCase();
    const dbPlanName = (posplanInDB && posplanInDB.toUpperCase()) || (plan && plan.toUpperCase());
    const planName = dbPlanName || queryPlanName
    const assetsPath = `${CONTEXT_ROOT}/assets/images/`;

    return (
      <div
        className="align-toolbar"
        onMouseEnter={() => !this.state.showTooltip && this.setState({ showTooltip: true })}
        onMouseLeave={() => this.state.showTooltip && this.setState({ showTooltip: false })}
      >
        <div className="toolbar">
          <div
            className={
              "img-container " + ((Plan.FLEX === planName || Plan.FLEXCRS===planName) ? "flex" : "flat")
            }
          >
            <img
              src={
                assetsPath +
                ((Plan.FLEX === planName || Plan.FLEXCRS===planName) ? "easyflexbadge.png" : "easyflatbadge.png")
              }
              alt={planName}
            />
          </div>
          <span>
            <b>POS EASY</b>
            <br />
            {(Plan.FLEX === planName || Plan.FLEXCRS===planName) ? "A commissioni" : "A canone"}
          </span>
          <img className="info-icon" src={assetsPath + "info.svg"} alt="info" />
        </div>
        {this.state.showTooltip && (
          <ul className="tooltip">
            <li>
              <b>POS  {(Plan.FLEX === planName || Plan.FLEXCRS===planName) ? "in vendita :" : " in Comodato d'uso"}</b>
              <br />
              {(Plan.FLEX === planName || Plan.FLEXCRS===planName) ? <span>100 € + IVA</span> : ""}
            </li>
            <li>
              <b>Commissioni:</b> {" "}
              {(Plan.FLEX === planName || Plan.FLEXCRS===planName ? "1%" : "0 €")}
            </li>
            <li>
              <b>Canone mensile:</b>{" "}
              {(Plan.FLEX === planName || Plan.FLEXCRS===planName) ? ("0 €") : (
                <React.Fragment>
                  <br />17 € + IVA se transi meno di 10.000 €
                  <br />22 € + IVA se transi tra 10.000 e 30.000 €
                </React.Fragment>
              )}
            </li>
            <li>
              <b>Attivazione:</b> 16 € di bollo
              <br/>
              {/* {(Plan.FLAT === planName || Plan.FLATCRS===planName) ? <div className="maindiv">
                     <div className="innerdiv1">
                       <div className="innersubdiv">
                       <span className="promocolor">Promo*</span>
                       </div>
                      </div>
                      <div className="innerdiv2">
                        <b>2 mesi di canone gratis</b> can il codice promozionale <b>EASYX2</b>
                      </div>
                  </div>:""}
              {(Plan.FLAT === planName || Plan.FLATCRS===planName) && <div className="grayed">
                Se sei già in possesso di un codice promozionale puoi inserirlo all'ultimo step, dopo la firma dei contratti.
              </div>} */}
            </li>
          </ul>
        )}
      </div>
    );
  }
}

export default PlanToolbar;
// PlanToolbar.propTypes = {
//   component: PropTypes.object.isRequired
// }

// const mapStateToProps = (state) => {
//   const { step } = state
//   return step
// }

// export default connect(mapStateToProps)(withStyles(Styles)(PlanToolbar))



// WEBPACK FOOTER //
// ./components/planToolbar/index.js